import React, { useEffect, useState } from 'react'
import ToolTip from '../../../ToolTip/ToolTip';
import ArrowUp from '../../../ArrowUp/ArrowUp';
import ArrowDown from '../../../ArrowDown/ArrowDown';
import "./styles.css"
import HoldingsTableData from '../HoldingsTableData';


export const SYMBOL = { key: 'id', label: 'Symbol' };
export const NAME = { key: 'popup', label: 'Name' };
export const CLOSING_PRICE = { key: 'closing_price', label: 'Closing Price' };
export const QUANTITY = { key: 'size', label: 'Quantity'};
export const CLOSING_VALUE = { key: 'closing_value', label: 'Closing Value' };
export const HOLDING_PERCENTAGE = { key: 'holding_pct', label: 'Holding %' };
export const CURRENT_PRICE = { key: 'current_price', label: 'Current Price' };
export const DAILY_GAIN_DOLLAR = { key: 'daily_gain', label: 'Daily Gain $'} ;
export const DAILY_GAIN_PERCENTAGE = { key: 'daily_gain_pct', label: 'Daily Gain %' };

const HoldingsTable = ({ data, activeTab, setTableRowId, setSortedDataToParent }) => {

    const tableHeadersMap = {
        securities: [SYMBOL, NAME, CLOSING_PRICE, QUANTITY, CLOSING_VALUE, HOLDING_PERCENTAGE, CURRENT_PRICE, DAILY_GAIN_DOLLAR, DAILY_GAIN_PERCENTAGE],
        asset_class: [SYMBOL, CLOSING_VALUE, HOLDING_PERCENTAGE, DAILY_GAIN_DOLLAR, DAILY_GAIN_PERCENTAGE],
        investment_category: [SYMBOL, CLOSING_VALUE, HOLDING_PERCENTAGE, DAILY_GAIN_DOLLAR, DAILY_GAIN_PERCENTAGE],
        investment_type: [SYMBOL, CLOSING_VALUE, HOLDING_PERCENTAGE, DAILY_GAIN_DOLLAR, DAILY_GAIN_PERCENTAGE],
        global: [SYMBOL, CLOSING_VALUE, HOLDING_PERCENTAGE, DAILY_GAIN_DOLLAR, DAILY_GAIN_PERCENTAGE]
    }

    const headers = tableHeadersMap[activeTab];

    const [sortedData, setSortedData] = useState(data);
    const [sortConfig, setSortConfig] = useState({ key: HOLDING_PERCENTAGE.key, direction: "desc" });
    const handleOnMouseEnter = (id) => {
        setTableRowId(id);
    }

    const handleOnMouseLeave = () => {
        setTableRowId(null);
    }

    // Initialize Active Tab
    useEffect(() => {
        const isExistingHeader = headers.some((header) => {
            return header.key === sortConfig.key;
        })

        if(isExistingHeader) {
            return;
        }

        setSortConfig({ key: HOLDING_PERCENTAGE.key, direction: "desc" });

    }, [activeTab])

    // Sorting
    useEffect(() => {
        const rowData = [...data].sort((a, b) => {
            const factor = sortConfig.direction === 'asc' ? 1 : -1;
            let itemA = a[sortConfig.key];
            let itemB = b[sortConfig.key];

            if(sortConfig.key === SYMBOL.key || sortConfig.key === NAME.key) {
                itemA = itemA.toLowerCase();
                itemB = itemB.toLowerCase();
            }

            return itemA > itemB ? factor : -factor;
        });

        setSortedData(rowData);
        setSortedDataToParent(rowData);
    }, [sortConfig.key, sortConfig.direction, data])


    const handleOnClick = (key) => {
        setSortConfig((prev) => {
            // if(key === prev.key && prev.direction === 'asc') {
            //     return { key, direction: 'desc' };
            // }

            // if(key === prev.key && prev.direction === 'desc') {
            //     return { key: SYMBOL.key, direction: 'asc' };
            // }

            // if(key !== prev.key) {
            //     return { key, direction: 'asc' }
            // }

            if(key === prev.key && prev.direction === 'desc') {
                if(key === HOLDING_PERCENTAGE.key) {
                    return { key, direction: 'asc' };
                }

                return { key: HOLDING_PERCENTAGE.key, direction: 'desc' };
            }

            if(key === prev.key && prev.direction === 'asc') {
                return { key, direction: 'desc' };
            }

            if(key !== prev.key) {
                return { key, direction: 'asc' };
            }
        });
    }

    return (
        <div>
            <table style={{ width: '100%' }}>
                <thead style={{ position: 'sticky', top: '0', backgroundColor: '#fff', zIndex: '9999' }}>
                    <tr className='holdings-table-header-row'>
                        {headers.map((item) => (
                            <th key={item.label} onClick={() => handleOnClick(item.key)}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ flex: '1 1 auto', marginRight: '4px' }}>{item.label}</div>
                                    {item.key === CURRENT_PRICE.key && <ToolTip style={{ transform: 'translateX(25%' }} text={'Live prices are delayed by 15 minutes'} />}

                                    <div style={{ marginLeft: '8px' }}>
                                        {item.key !== sortConfig.key && <div style={{ height: '16px', width: '16px' }}></div>}
                                        {item.key === sortConfig.key && sortConfig.direction === 'asc' && <ArrowUp />}
                                        {item.key === sortConfig.key && sortConfig.direction === 'desc' && <ArrowDown />}
                                    </div>

                                </div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody onMouseLeave={handleOnMouseLeave}>
                    {sortedData.map((row, rowIndex) => (
                        <tr key={rowIndex} className='holdings-table-row' onMouseEnter={(e) => handleOnMouseEnter(row.id)}>
                            {headers.map((item) => (
                                <td key={item.label}>
                                    <HoldingsTableData item={row[item.key]} header={item.label} />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default HoldingsTable